/* istanbul ignore file */
import { useParams } from 'react-router-dom';
// components
import { DeleteButtonProps, DeleteButton } from 'framework/ui/ui-builder';
// services
import { useContactUrl } from 'domain/sales/contact/contactRouting';
import useContactService from 'domain/sales/contact/shared/contactService';

const deleteMessage = 'Do you really want to delete this contact?';

const DeleteContactButton = (props: Omit<DeleteButtonProps, 'deleteMethod' | 'displayMessage'>) => {
  const { id: contactId = '' } = useParams<Dictionary<string>>();
  const { getListUrl } = useContactUrl();
  const { deleteById } = useContactService();

  return (
    <DeleteButton
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Contact has been successfully deleted.',
        errorMessage: `Can't delete contact`,
      }}
      {...props}
      deleteMethod={() => deleteById(contactId)}
      displayMessage={deleteMessage}
    />
  );
};

export default DeleteContactButton;
